import moment from "moment";

function uid() {
  return Math.random().toString(36).substr(2);
}

export const generateUniqueFileName = (file) => {
  const uniqueName = `${moment().format("YYYYMMDDHHmmss")}_${uid()}`;
  const extensionMatch = file.name.match(/\.\w+$/g);
  return extensionMatch ? `${uniqueName}${extensionMatch[0]}` : uniqueName;
};
